import { Injectable } from '@angular/core';
import { IVisualStateService } from "@common/interfaces/i-visual-state-service";
import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { Record } from '@common/data-models/records/record';
import { BreakpointObserver } from '@angular/cdk/layout';
import { StorytellingLayoutBreakpoints } from '@common/enums/constants';

@Injectable({ providedIn: 'root' })
export class VisualStateService implements IVisualStateService {
    isSingleDesktopItem: boolean = false;
    isDesktop: boolean = false;
    isMobile: boolean = false;
    isIpad: boolean = false;
    isIOSDevice: boolean = false;
    isAndroidTablet: boolean = false;
    isAndroidDevice: boolean = false;
    autoLoginWrapper: boolean = false;
    isEmbedded: boolean = false;
    userPreffersDarkMode: boolean = false;


    constructor(
        public nomWebServicesJson: NomWebServicesJson,
        private breakpointObserver: BreakpointObserver
    ) {
        this.isMobile = this.checkForMobile();
        this.isIpad = this.checkForIpad();
        this.isIOSDevice = this.checkForIOSDevice();
        this.isAndroidTablet = this.checkForAndroidTablet();
        this.isAndroidDevice = this.checkForAndroidDevice();

        Record.visualStateService = this;
        this.userPreffersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

        breakpointObserver
            .observe([
                StorytellingLayoutBreakpoints.XSmall,
                StorytellingLayoutBreakpoints.Small,
                StorytellingLayoutBreakpoints.Medium,
                StorytellingLayoutBreakpoints.Large,
                StorytellingLayoutBreakpoints.XLarge,
                StorytellingLayoutBreakpoints.XXLarge,
            ])
            .subscribe();
    }

    get shouldPanelsFloat(): boolean {
        return this.breakpointObserver.isMatched([
            StorytellingLayoutBreakpoints.XSmall,
            StorytellingLayoutBreakpoints.Small,
            StorytellingLayoutBreakpoints.Medium,
            StorytellingLayoutBreakpoints.Large,
            StorytellingLayoutBreakpoints.XLarge
        ]);
    }

    get isLessThanMedium(): boolean {
        return this.breakpointObserver.isMatched([
            StorytellingLayoutBreakpoints.XSmall,
            StorytellingLayoutBreakpoints.Small,
            StorytellingLayoutBreakpoints.Medium
        ]);
    }

    get isLessThanLarge(): boolean {
        return this.breakpointObserver.isMatched([
            StorytellingLayoutBreakpoints.XSmall,
            StorytellingLayoutBreakpoints.Small,
            StorytellingLayoutBreakpoints.Medium,
            StorytellingLayoutBreakpoints.Large
        ]);
    }


    get isLessThanXLarge(): boolean {
        return this.breakpointObserver.isMatched([
            StorytellingLayoutBreakpoints.XSmall,
            StorytellingLayoutBreakpoints.Small,
            StorytellingLayoutBreakpoints.Medium,
            StorytellingLayoutBreakpoints.Large,
            StorytellingLayoutBreakpoints.XLarge
        ]);
    }


    get isLessThanSmall(): boolean {
        return this.breakpointObserver.isMatched([
            StorytellingLayoutBreakpoints.XSmall,
            StorytellingLayoutBreakpoints.Small
        ]);
    }

    get isLessThanXSmall(): boolean {
        return this.breakpointObserver.isMatched([
            StorytellingLayoutBreakpoints.XSmall
        ]);
    }

    get isTouchDevice(): boolean {
        return !!('ontouchstart' in window) || !!('onmsgesturechange' in window);
    };




    public ConfigSettings: { [id: string]: any } = {};

    public checkForMobile() {
        if ((navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i))
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPod/i)) {
            return true;
        } else {
            return false;
        }
    }

    private checkForIpad() {
        if (navigator.userAgent.match(/iPad/i)) {
            return true;
        } else {
            return false;
        }
    }

    public checkForIOSDevice() {
        if (navigator.userAgent.match(/iPad||iPod||iPhone/i)) {
            return true;
        } else {
            return false;
        }
    }

    public hasIOSInterOp() {
        return window["webkit"] && window["webkit"].messageHandlers && window["webkit"].messageHandlers.interOp && window["webkit"].messageHandlers.interOp.postMessage;
    }

    private checkForAndroidTablet() {
        if (navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/Mobile/i)) {
            return true;
        } else {
            return false;
        }
    }
    private checkForAndroidDevice() {
        if (navigator.userAgent.match(/Android/i)) {
            return true;
        } else {
            return false;
        }
    }

    public checkIfWrapper() {
        return this.checkIfAdroidWrapper() || this.checkIfAdroidWrapper();
    }

    public checkIfiOSWrapper() {
        let appID = localStorage.getItem("AppId");
        if (appID && appID == "IOSWRAPPER") {
            return true;
        } else {
            return false;
        }
    }

    public checkIfAdroidWrapper() {
        let appID = localStorage.getItem("AppId");
        if (appID && appID == "ANDROIDWRAPPER") {
            return true;
        } else {
            return false;
        }
    }



    //Expander settings
    public expanderSettingsMap: { [id: string]: { [id: string]: boolean } } = {};

    public async saveExpanderSettings(expanderLocation: string, title: string, opened: boolean) {
        if (!this.expanderSettingsMap[expanderLocation]) this.expanderSettingsMap[expanderLocation] = {};
        this.expanderSettingsMap[expanderLocation][title] = opened;
        localStorage.setItem(this.nomWebServicesJson.HelloResults.UserID + "ExpanderSettings", JSON.stringify(this.expanderSettingsMap))
    }

    public getExpanderSettings() {
        let jsonStr = localStorage.getItem(this.nomWebServicesJson.HelloResults.UserID + "ExpanderSettings")
        let expanderSettings = null;
        if (jsonStr) expanderSettings = JSON.parse(jsonStr);
        if (expanderSettings) this.expanderSettingsMap = expanderSettings;
    }

}
